import { useRef } from "react";
import "./Modal.css";
import "../../css/Icons.css";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  style: any;
  children: any;
  canClose?: boolean;
  isDrawer?: boolean;
  escapeToClose?: boolean;
  allowClickout?: boolean;
};

const Modal = ({
  isOpen,
  onClose,
  canClose = true,
  isDrawer = false,
  style,
  children,
  escapeToClose = false,
  allowClickout = false,
}: ModalProps) => {
  const modalRef = useRef(null);

  const handleKeyDown = (e: any) => {
    if (escapeToClose && e.key === "Escape") {
      onClose();
      e.stopPropagation();
    }
  };

  const handleClick = (e: any) => {
    // console.log("[Modal/handleClic] e: ", e);
    // console.log("[Modal/handleClic] modal ref: ", modalRef?.current);

    if (allowClickout && modalRef && e.target === modalRef.current) {
      onClose();
      e.stopPropagation();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div
      ref={modalRef}
      className="modal-container"
      onMouseOver={(e: any) => e.stopPropagation()}
      onMouseEnter={(e: any) => e.stopPropagation()}
      onClick={handleClick}>
      {isDrawer && <>{children}</>}

      {!isDrawer && (
        <div
          className="modal-content"
          style={style}
          onClick={(e: any) => {
            e.stopPropagation();
          }}>
          {children}
          {canClose && (
            <div className="modal-close" onClick={onClose}>
              <img className="icon-close" alt="" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Modal;
